import { ModuleFE_AdvisorSession, ModuleFE_RuntimeFinding, } from '@app/advisor-frontend';
import { findingSourceTypesEnum, FindingType_Enumerated, FindingType_Numeric, FindingType_Textual, } from '@app/advisor-shared';
import { ModuleFE_Advisor_Expression, ModuleFE_Advisor_MeasurementUnit, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import { ExpressionType_NormalRange } from '@app/hcs-shared/expression';
import { exists, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
export const getVarNormal = (variable) => {
    const varExpression = ModuleFE_Advisor_Expression.cache.find(exp => exp.associatedVar === variable._id
        && exp.expressionType === ExpressionType_NormalRange.dbKey);
    const expressionFindings = ModuleFE_RuntimeFinding.cache.filter(finding => finding.variableId === varExpression?._id);
    const latestExpressionFinding = sortArray(expressionFindings, finding => finding.__created, true)[0];
    const range = latestExpressionFinding?.value;
    if (!range || !exists(range[0]) || !exists(range[1]))
        return;
    return range;
};
const getSource = (findingResult) => {
    if (findingResult?.source.type === findingSourceTypesEnum.SMARTDOC)
        return;
    return findingResult?.source.type;
};
const getMeasurementUnitId = (variable) => {
    const value = ModuleFE_Advisor_Value.cache.unique(variable.valueId);
    return value?.data?.unitsId;
};
export const tooltipFindingsTranslation = (findingResults) => {
    const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
    const results = findingResults.findings.reduce((results, finding) => {
        const result = {
            timestamp: finding.issuedTimestamp ?? finding.__created,
            currentEncounter: finding.encounterId === encounterId
        };
        switch (finding.type) {
            case 'range':
                return results;
            case FindingType_Enumerated: {
                result.valueId = finding.valueIds[0];
                //Translate Finding Attributes
                result.attributes = finding.attributes?.map(attribute => {
                    const attVar = ModuleFE_Advisor_Variable.cache.unique(attribute.variableId);
                    if (!attVar)
                        throw new MUSTNeverHappenException(`Could not find variable for id ${attribute.variableId}`);
                    return {
                        variable: attVar,
                        results: [{
                                valueId: attribute.valueIds[0],
                                timestamp: result.timestamp,
                                currentEncounter: result.currentEncounter,
                            }],
                        metadata: {},
                    };
                });
                break;
            }
            case FindingType_Numeric:
                result.rawValue = finding.value;
                break;
            case FindingType_Textual:
                result.rawValue = finding.value;
                break;
        }
        results.push(result);
        return results;
    }, []);
    return {
        variable: findingResults.variable,
        results: results,
        metadata: {
            varNormal: getVarNormal(findingResults.variable),
            source: getSource(findingResults.findings[0]),
            measurementUnitId: getMeasurementUnitId(findingResults.variable),
        },
    };
};
export const tooltipFindingsModules = {
    variable: ModuleFE_Advisor_Variable,
    value: ModuleFE_Advisor_Value,
    measurementUnit: ModuleFE_Advisor_MeasurementUnit,
};
//# sourceMappingURL=tooltip-findings.js.map